// extracted by mini-css-extract-plugin
export var activityContainer = "_h8-0";
export var typingIndicatorContainer = "_h8-1";
export var typingIndicatorDot = "_h8-2";
export var wave = "_h8-3";